export default "__VITE_ASSET__m$xs7wEB__"